const questions: Record<string, PolicyFormQuestion> = {
  // Client Insured Question
  clientInsured: {
    id: 'q-client-insured',
    questionRef: 'clientInsured',
    title: 'Will {clientFullName} be the insured individual on this policy?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  // Primary Insured Contact Information
  primaryInsuredFirstName: {
    id: 'primary-insured-first-name',
    questionRef: 'primaryInsuredFirstName',
    title: 'First name',
    type: 'text',
    required: false,
    placeholder: 'First name',
    conditional: {
      visible: {
        field: 'clientInsured',
        operator: 'equals',
        value: 'no',
      },
      required: {
        field: 'clientInsured',
        operator: 'equals',
        value: 'no',
      },
    },
  },

  primaryInsuredLastName: {
    id: 'primary-insured-last-name',
    questionRef: 'primaryInsuredLastName',
    title: 'Last name',
    type: 'text',
    required: false,
    placeholder: 'Last name',
    conditional: {
      visible: {
        field: 'clientInsured',
        operator: 'equals',
        value: 'no',
      },
      required: {
        field: 'clientInsured',
        operator: 'equals',
        value: 'no',
      },
    },
  },

  primaryInsuredEmail: {
    id: 'primary-insured-email',
    questionRef: 'primaryInsuredEmail',
    title: 'Email',
    type: 'text',
    required: false,
    placeholder: 'Email address',
    validationType: 'email',
    conditional: {
      visible: {
        field: 'clientInsured',
        operator: 'equals',
        value: 'no',
      },
      required: {
        field: 'clientInsured',
        operator: 'equals',
        value: 'no',
      },
    },
  },

  // Policy Owners Question
  policyOwners: {
    id: 'q-policy-owners',
    questionRef: 'policyOwners',
    title: 'Who will be the owner of this policy?',
    type: 'select',
    required: true,
    options: [
      { id: 'owner_client', value: '{clientFullName}' },
      { id: 'owner_joint', value: 'Joint ownership' },
      { id: 'owner_trust', value: 'Trust' },
      { id: 'owner_other', value: 'Other individual' },
      { id: 'owner_joint_other', value: 'Joint ownership (other)' },
    ],
  },

  // Joint Owner Contact Information
  jointOwnerFirstName: {
    id: 'joint-owner-first-name',
    questionRef: 'jointOwnerFirstName',
    title: 'First name',
    type: 'text',
    required: false,
    placeholder: 'First name',
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint',
      },
      required: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint',
      },
    },
  },

  jointOwnerLastName: {
    id: 'joint-owner-last-name',
    questionRef: 'jointOwnerLastName',
    title: 'Last name',
    type: 'text',
    required: false,
    placeholder: 'Last name',
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint',
      },
      required: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint',
      },
    },
  },

  jointOwnerEmail: {
    id: 'joint-owner-email',
    questionRef: 'jointOwnerEmail',
    title: 'Email',
    type: 'text',
    required: false,
    placeholder: 'Email address',
    validationType: 'email',
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint',
      },
      required: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint',
      },
    },
  },

  // Trust Contact Information
  ownerTrustName: {
    id: 'owner-trust-name',
    questionRef: 'ownerTrustName',
    title: 'Trust name',
    type: 'text',
    required: false,
    placeholder: 'Trust name',
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_trust',
      },
      required: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_trust',
      },
    },
  },

  ownerTrustEmail: {
    id: 'owner-trust-email',
    questionRef: 'ownerTrustEmail',
    title: 'Trust email',
    type: 'text',
    required: false,
    placeholder: 'Email address',
    validationType: 'email',
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_trust',
      },
      required: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_trust',
      },
    },
  },

  // Other Owner Contact Information
  ownerOtherFirstName: {
    id: 'owner-other-first-name',
    questionRef: 'ownerOtherFirstName',
    title: 'First name',
    type: 'text',
    required: false,
    placeholder: 'First name',
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'in',
        value: ['owner_other', 'owner_joint_other'],
      },
      required: {
        field: 'policyOwners',
        operator: 'in',
        value: ['owner_other', 'owner_joint_other'],
      },
    },
  },

  ownerOtherLastName: {
    id: 'owner-other-last-name',
    questionRef: 'ownerOtherLastName',
    title: 'Last name',
    type: 'text',
    required: false,
    placeholder: 'Last name',
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'in',
        value: ['owner_other', 'owner_joint_other'],
      },
      required: {
        field: 'policyOwners',
        operator: 'in',
        value: ['owner_other', 'owner_joint_other'],
      },
    },
  },

  ownerOtherEmail: {
    id: 'owner-other-email',
    questionRef: 'ownerOtherEmail',
    title: 'Email',
    type: 'text',
    required: false,
    placeholder: 'Email address',
    validationType: 'email',
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'in',
        value: ['owner_other', 'owner_joint_other'],
      },
      required: {
        field: 'policyOwners',
        operator: 'in',
        value: ['owner_other', 'owner_joint_other'],
      },
    },
  },

  // Joint Other Owner Contact Information
  ownerJointOtherFirstName: {
    id: 'owner-joint-other-first-name',
    questionRef: 'ownerJointOtherFirstName',
    title: 'Joint owner first name',
    type: 'text',
    required: false,
    placeholder: 'First name',
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint_other',
      },
      required: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint_other',
      },
    },
  },

  ownerJointOtherLastName: {
    id: 'owner-joint-other-last-name',
    questionRef: 'ownerJointOtherLastName',
    title: 'Joint owner last name',
    type: 'text',
    required: false,
    placeholder: 'Last name',
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint_other',
      },
      required: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint_other',
      },
    },
  },

  ownerJointOtherEmail: {
    id: 'owner-joint-other-email',
    questionRef: 'ownerJointOtherEmail',
    title: 'Joint owner email',
    type: 'text',
    required: false,
    placeholder: 'Email address',
    validationType: 'email',
    conditional: {
      visible: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint_other',
      },
      required: {
        field: 'policyOwners',
        operator: 'equals',
        value: 'owner_joint_other',
      },
    },
  },

  // Policy Payor Question
  policyPayor: {
    id: 'q-policy-payor',
    questionRef: 'policyPayor',
    title: 'Who will be paying for this policy?',
    type: 'select',
    required: true,
    options: [
      { id: 'payor_client', value: '{clientFullName}' },
      { id: 'payor_owner', value: 'Policy owner (if different from insured)' },
      { id: 'payor_other', value: 'Other individual' },
    ],
  },

  // Payor Other Contact Information
  payorOtherFirstName: {
    id: 'payor-other-first-name',
    questionRef: 'payorOtherFirstName',
    title: 'First name',
    type: 'text',
    required: false,
    placeholder: 'First name',
    conditional: {
      visible: {
        field: 'policyPayor',
        operator: 'equals',
        value: 'payor_other',
      },
      required: {
        field: 'policyPayor',
        operator: 'equals',
        value: 'payor_other',
      },
    },
  },

  payorOtherLastName: {
    id: 'payor-other-last-name',
    questionRef: 'payorOtherLastName',
    title: 'Last name',
    type: 'text',
    required: false,
    placeholder: 'Last name',
    conditional: {
      visible: {
        field: 'policyPayor',
        operator: 'equals',
        value: 'payor_other',
      },
      required: {
        field: 'policyPayor',
        operator: 'equals',
        value: 'payor_other',
      },
    },
  },

  payorOtherEmail: {
    id: 'payor-other-email',
    questionRef: 'payorOtherEmail',
    title: 'Email',
    type: 'text',
    required: false,
    placeholder: 'Email address',
    validationType: 'email',
    conditional: {
      visible: {
        field: 'policyPayor',
        operator: 'equals',
        value: 'payor_other',
      },
      required: {
        field: 'policyPayor',
        operator: 'equals',
        value: 'payor_other',
      },
    },
  },

  // Payment Method Question
  paymentMethod: {
    id: 'q-payment-method',
    questionRef: 'paymentMethod',
    title:
      'Will this policy be paid for using any of a Full 1035 Exchange, IRA Transfer, Direct Rollover, CD Assignment, or Mutual Fund Transfer?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },

  // 1035 Exchange Question
  exchange1035: {
    id: 'q-1035-exchange',
    questionRef: 'exchange1035',
    title: 'Will this policy be paid for using a partial or full 1035 exchange?',
    type: 'select',
    required: false,
    options: [
      { id: 'yes_full_1035', value: 'Yes - Full 1035 exchange' },
      { id: 'yes_partial_1035', value: 'Yes - Partial 1035 exchange' },
      { id: 'no_1035', value: 'No' },
    ],
    conditional: {
      visible: {
        field: 'paymentMethod',
        operator: 'equals',
        value: 'yes',
      },
      required: {
        field: 'paymentMethod',
        operator: 'equals',
        value: 'yes',
      },
    },
  },

  // Policy Replacement Question
  policyReplacement: {
    id: 'q-policy-replacement',
    questionRef: 'policyReplacement',
    title: 'Will this policy be replacing an existing life insurance policy or annuity?',
    type: 'radio',
    required: true,
    options: [
      { id: 'yes', value: 'Yes' },
      { id: 'no', value: 'No' },
    ],
  },
};

export const nationwidePreApplicationFormDefinition: PolicyFormDefinition = {
  requiredParameters: [
    {
      key: 'clientFullName',
      description: 'The full name of the client for personalizing form questions',
      type: 'string',
      required: true,
    },
    {
      key: 'fundingPolicyType',
      description: 'The type of policy being applied for',
      type: 'number',
      required: true,
    },
  ] as FormParameter[],
  sections: [
    /* 2 ▸ Ownership Information ------------------------------------------------- */
    {
      id: 'ownership-info',
      title: 'Policy Ownership',
      subsections: [
        {
          id: 'ownership-selection',
          title: 'Policy ownership details',
          questionGroups: [
            {
              id: 'policy-owners-group',
              format: 'default',
              questions: ['policyOwners'],
            },
            {
              id: 'joint-owner-contact-group',
              format: 'default',
              questions: ['jointOwnerFirstName', 'jointOwnerLastName', 'jointOwnerEmail'],
              title: 'Who will jointly own the policy with {clientFullName}?',
              conditional: {
                visible: {
                  field: 'policyOwners',
                  operator: 'equals',
                  value: 'owner_joint',
                },
              },
            },
            {
              id: 'owner-trust-contact-group',
              format: 'default',
              questions: ['ownerTrustName', 'ownerTrustEmail'],
              title: 'What is the name and contact information for the trust?',
              conditional: {
                visible: {
                  field: 'policyOwners',
                  operator: 'equals',
                  value: 'owner_trust',
                },
              },
            },
            {
              id: 'owner-other-contact-group',
              format: 'default',
              questions: [
                'ownerOtherFirstName',
                'ownerOtherLastName',
                'ownerOtherEmail',
                'ownerJointOtherFirstName',
                'ownerJointOtherLastName',
                'ownerJointOtherEmail',
              ],
              title: 'Who will be the owner of this policy?',
              conditional: {
                visible: {
                  field: 'policyOwners',
                  operator: 'in',
                  value: ['owner_other', 'owner_joint_other'],
                },
              },
            },
          ],
        },
      ],
    },
    /* 4 ▸ Payment Information --------------------------------------------------- */
    {
      id: 'payment-info',
      title: 'Payment Information',
      subsections: [
        /* Removed for now since payor is not a signing role*/
        {
          id: 'payor-selection',
          title: 'Who will pay for the policy',
          questionGroups: [
            {
              id: 'policy-payor-group',
              format: 'default',
              questions: ['policyPayor'],
            },
          ],
        },
        {
          id: 'payment-method',
          title: 'Payment method',
          questionGroups: [
            {
              id: 'payment-method-group',
              format: 'default',
              questions: ['paymentMethod'],
            },
            {
              id: '1035-exchange-group',
              format: 'default',
              questions: ['exchange1035'],
              conditional: {
                visible: {
                  field: 'paymentMethod',
                  operator: 'equals',
                  value: 'yes',
                },
              },
            },
          ],
        },
      ],
    },

    /* 5 ▸ Policy Replacement --------------------------------------------------- */
    {
      id: 'policy-replacement',
      title: 'Policy Replacement',
      subsections: [
        {
          id: 'replacement-info',
          title: 'Replacement information',
          questionGroups: [
            {
              id: 'policy-replacement-group',
              format: 'default',
              questions: ['policyReplacement'],
            },
          ],
        },
      ],
    },
  ],

  /* ---------- Question record -------------------------------------------------- */
  questions,
};
